import { render, staticRenderFns } from "./RejectHistory.vue?vue&type=template&id=614636b6&scoped=true"
import script from "./RejectHistory.vue?vue&type=script&lang=js"
export * from "./RejectHistory.vue?vue&type=script&lang=js"
import style0 from "./RejectHistory.vue?vue&type=style&index=0&id=614636b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614636b6",
  null
  
)

export default component.exports